import { render, staticRenderFns } from "./SolutionSheetItemSpanRestraintsSubItemFibreLower.vue?vue&type=template&id=328ff90b&scoped=true&"
import script from "./SolutionSheetItemSpanRestraintsSubItemFibreLower.vue?vue&type=script&lang=js&"
export * from "./SolutionSheetItemSpanRestraintsSubItemFibreLower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ff90b",
  null
  
)

export default component.exports